import { gql } from 'apollo-angular';

/**
 * Mutations related to authentication.
 */
export class AuthenticationMutations {
	public static consumeOneTimeToken = gql`
		mutation consumeOneTimeToken($token: String!) {
			consumeOneTimeToken(token: $token) {
				Company
				Email
				IsAuthenticated
				SessionUID
				Username
			}
		}
	`;
}
